/**
 * Block all inline scripts (e.g. <script>...</script>) to prevent
 * them from running when a fragment is loaded. This is a security
 * measure to prevent any inline scripts from executing, which can
 * help mitigate certain types of cross-site scripting (XSS) attacks.
 * https://unpoly.com/script-security#script-elements
 * @type {string}
 */
up.script.config.scriptElementPolicy = 'block';

/**
 * Disable Unpoly's own in-memory response cache so every navigation fetches
 * fresh from the server. Servd's static / CDN cache (whose TTLs we control) is
 * then the single cache layer. cacheSize = 0 means no response is ever retained
 * or served from Unpoly's cache.
 *
 * This is also why preloading is deliberately NOT enabled below: preload exists
 * only to warm this cache, so with the cache off it would just double-fetch
 * (hover discards, click re-fetches) and pummel the origin on every hover.
 * Trade-off: navigations are fresh fetches rather than instant cache hits — still
 * faster than a cold load (warm CSS/JS/Alpine, no re-parse, no FOUC), but not the
 * sub-100ms preload feel. Re-enable both together if that trade isn't worth it.
 * https://unpoly.com/up.network.config#config.cacheSize
 * @type {number}
 */
up.network.config.cacheSize = 0;

/**
 * Selectors we DO want Unpoly to follow.
 * Following every internal link turns the site into an Unpoly app:
 * https://unpoly.com/handling-everything
 * @type {string[]}
 */
const yesSelectors = ['a[href]'];

/**
 * Selectors we do NOT want Unpoly to follow.
 *
 * Unpoly 3 already excludes cross-origin links, downloads, `target`,
 * `mailto:`/`tel:`/`javascript:` schemes and in-page `#` anchors by
 * default (see up.link.config.noFollowSelectors), so we only add the
 * same-origin paths it would otherwise hijack:
 *   - Craft action requests (POST-ish endpoints, CSRF, redirects)
 *   - auth pages + their forms, which must run as full page loads
 *   - logout, which flips the SERVD_LOGGED_IN_STATUS cookie / cache mode
 *
 * @type {string[]}
 */
const noSelectors = [
  'a[href*="/actions/"]',
  'a[href*="/login"]',
  'a[href*="/logout"]',
  'a[href*="/sign-up"]',
  'a[href*="/reset-password"]',
  'a[href*="/setpassword"]',
];

/**
 * Automatically follow (most) internal links.
 * Preloading is intentionally left off — see the cacheSize note above.
 * https://unpoly.com/up.link.config#config.followSelectors
 * https://unpoly.com/up.link.config#config.noFollowSelectors
 */
up.link.config.followSelectors.push(...yesSelectors);
up.link.config.noFollowSelectors.push(...noSelectors);
